import { createSlice } from '@reduxjs/toolkit';

import {
  getArcades,
  getSchoolArcades,
  updateArcadeById,
  removeArcadeById,
} from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 10,
};

const arcadesSlice = createSlice({
  name: 'arcades',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getArcades.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(getSchoolArcades.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(updateArcadeById.fulfilled, (state: any, action: any) => {
      const { fieldName, updatedArcade } = action.payload;

      return {
        ...state,
        data: state.data.map((arcade: any) => {
          if (arcade.id === updatedArcade.id) {
            return {
              ...arcade,
              [fieldName]: updatedArcade[fieldName],
            };
          }

          return arcade;
        }),
      };
    });

    builder.addCase(removeArcadeById, (state: any, action: any) => {
      return {
        ...state,
        data: state.data.filter((arcade: any) => arcade.id !== action.payload),
      };
    });
  },
});

export default arcadesSlice.reducer;
